import { useState } from "react";
import { appPlatforms } from "@/mocks/homeData";

export default function AppDownloadSection() {
  const [activeKey, setActiveKey] = useState(appPlatforms[0].key);
  const active = appPlatforms.find((item) => item.key === activeKey) ?? appPlatforms[0];

  return (
    <section id="app" className="w-full bg-background-50 py-16 md:py-24">
      <div className="w-full px-4 md:px-8 max-w-6xl mx-auto">
        <div className="max-w-2xl">
          <span className="inline-flex items-center gap-2 text-primary-600 text-sm font-medium">
            <i className="ri-download-2-line" />
            APP 下载指南
          </span>
          <h2 className="mt-3 font-heading text-foreground-950 text-2xl md:text-4xl">
            按你的设备，选择对应的获取方式
          </h2>
          <p className="mt-4 text-foreground-600 text-sm md:text-base leading-relaxed">
            交换设备或系统不同，下载方式也会有差异。切换下方标签，查看对应设备的具体步骤与注意事项。
          </p>
        </div>

        <div className="mt-8 inline-flex flex-wrap gap-2 p-1 rounded-full bg-background-100 border border-background-200/70">
          {appPlatforms.map((platform) => {
            const isActive = platform.key === activeKey;
            return (
              <button
                key={platform.key}
                type="button"
                onClick={() => setActiveKey(platform.key)}
                className={`inline-flex items-center gap-2 px-4 py-2 rounded-full text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                  isActive
                    ? "bg-primary-500 text-background-50"
                    : "text-foreground-600 hover:text-primary-600"
                }`}
              >
                <i className={platform.icon} />
                {platform.name}
              </button>
            );
          })}
        </div>

        <div className="mt-6 rounded-lg bg-background-100 border border-background-200/70 p-5 md:p-8">
          <div className="flex items-center gap-3">
            <span className="w-12 h-12 flex items-center justify-center rounded-lg bg-accent-500 text-background-50 text-2xl">
              <i className={active.icon} />
            </span>
            <div>
              <h3 className="font-heading text-foreground-950 text-xl">{active.name}</h3>
              <p className="mt-1 text-foreground-600 text-sm">{active.summary}</p>
            </div>
          </div>

          <div className="mt-7 grid grid-cols-1 lg:grid-cols-12 gap-7">
            <div className="lg:col-span-8">
              <h4 className="font-heading text-foreground-900 text-base">安装步骤</h4>
              <ol className="mt-4 space-y-3">
                {active.steps.map((step, index) => (
                  <li key={step} className="flex items-start gap-3">
                    <span className="shrink-0 w-7 h-7 flex items-center justify-center rounded-full bg-primary-100 text-primary-700 text-sm font-medium">
                      {index + 1}
                    </span>
                    <span className="text-foreground-700 text-sm leading-relaxed pt-0.5">{step}</span>
                  </li>
                ))}
              </ol>
            </div>

            <div className="lg:col-span-4">
              <div className="rounded-lg bg-secondary-50 border border-secondary-200/70 p-4 md:p-5">
                <div className="flex items-center gap-2 text-secondary-700 text-sm font-medium">
                  <i className="ri-lightbulb-line" />
                  注意事项
                </div>
                <ul className="mt-3 space-y-2">
                  {active.tips.map((tip) => (
                    <li key={tip} className="flex items-start gap-2 text-foreground-700 text-sm leading-relaxed">
                      <i className="ri-arrow-right-s-line text-secondary-500 mt-0.5" />
                      <span>{tip}</span>
                    </li>
                  ))}
                </ul>
              </div>
              <p className="mt-4 text-foreground-500 text-xs leading-relaxed">
                具体获取方式可能随平台调整，请以官方页面当前说明为准。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}